import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'terms',
    templateUrl: './terms.component.html',
    standalone: false
})
export class TermsComponent {}
